import { render, staticRenderFns } from "./FixedRatio.vue?vue&type=template&id=114c42b4&scoped=true&"
import script from "./FixedRatio.vue?vue&type=script&lang=js&"
export * from "./FixedRatio.vue?vue&type=script&lang=js&"
import style0 from "./FixedRatio.vue?vue&type=style&index=0&id=114c42b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c42b4",
  null
  
)

export default component.exports